import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { DelegatePublicInfo } from '@/shared/types/domain';

export const delegateLookupApi = {
  lookup: (scannedValue: string) =>
    httpClient.get<DelegatePublicInfo>(endpoints.delegates.lookup(scannedValue))
};
